import React, { useState } from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import MetaTags from "react-meta-tags";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchIcon from "@material-ui/icons/Search";

export default function Faqs() {
  const [activeTab, setActiveTab] = useState(0); // 0: User, 1: Partner
  const [searchQuery, setSearchQuery] = useState("");

  const userFaqs = [
    {
      q: "Bagaimana cara mendaftar akun di aplikasi UR?",
      a: (
        <ol style={{ paddingLeft: "20px", margin: 0, lineHeight: 1.8 }}>
          <li>Unduh aplikasi UR di Google Play Store atau Apple App Store.</li>
          <li>Buka aplikasi UR dan masukkan nomor telepon Anda yang aktif.</li>
          <li>Pastikan nomor telepon sama dengan nomor akun e-wallet Anda untuk kemudahan transaksi.</li>
          <li>Lengkapi data diri dasar Anda.</li>
          <li>Akun UR Anda langsung aktif dan siap digunakan.</li>
        </ol>
      ),
    },
    {
      q: "Bagaimana cara memesan makanan di resto dengan aplikasi UR?",
      a: (
        <ol style={{ paddingLeft: "20px", margin: 0, lineHeight: 1.8 }}>
          <li>Pada halaman utama aplikasi UR, pilih tombol 'Pesan Makanan'.</li>
          <li>Arahkan kamera ke kode QR yang tertera pada meja restoran.</li>
          <li>Pilih menu yang Anda inginkan beserta catatan khusus.</li>
          <li>Periksa ringkasan pesanan pada keranjang.</li>
          <li>Pilih 'Bayar' dan tentukan metode pembayaran (QRIS/e-Wallet/Tunai di kasir).</li>
          <li>Pesanan Anda otomatis masuk ke dapur dan siap diproses.</li>
        </ol>
      ),
    },
    {
      q: "Apakah penggunaan aplikasi UR memerlukan koneksi internet?",
      a: "Ya, aplikasi UR membutuhkan koneksi internet aktif agar setiap proses pemesanan, update status masak, dan validasi pembayaran digital dapat berjalan lancar secara real-time.",
    },
    {
      q: "Bagaimana dengan keamanan data pribadi saya?",
      a: "UR tunduk pada peraturan perlindungan data pribadi yang berlaku di Indonesia. Kami menerapkan enkripsi standar dan tidak membagikan informasi rahasia Anda kepada pihak ketiga tanpa izin.",
    },
    {
      q: "Metode pembayaran apa saja yang didukung oleh UR?",
      a: "UR mendukung seluruh pembayaran non-tunai melalui QRIS, GoPay, OVO, DANA, LinkAja, ShopeePay, serta pembayaran tunai dan kartu debit/kredit di meja kasir restoran.",
    },
    {
      q: "Apakah saya bisa melihat riwayat pesanan dan nota elektronik (e-receipt)?",
      a: "Tentu saja. Semua riwayat pesanan dan receipt digital tersimpan pada menu 'Pesanan' di aplikasi UR serta dikirimkan otomatis ke alamat email terdaftar Anda.",
    },
    {
      q: "Di mana saja saya bisa menggunakan aplikasi UR?",
      a: "Anda dapat melihat daftar seluruh restoran, cafe, dan merchant kuliner yang bekerja sama dengan UR melalui fitur 'Maps' di aplikasi UR.",
    },
    {
      q: "Apakah saya dapat mengubah data profil saya?",
      a: "Ya, Anda dapat memperbarui nama lengkap, alamat email, jenis kelamin, dan tanggal lahir kapan saja melalui menu 'Edit Profil' di aplikasi.",
    },
  ];

  const partnerFaqs = [
    {
      q: "Apa itu UR Partner?",
      a: "UR Partner adalah aplikasi Point-of-Sale (POS) dan manajemen restoran lengkap yang membantu merchant memproses order meja, pesanan online, stok bahan, laporan keuangan, dan program loyalitas pelanggan dalam satu sistem praktis.",
    },
    {
      q: "Apa keuntungan utama bergabung menjadi UR Partner?",
      a: "Efisiensi operasional hingga 3x lipat, pengurangan antrian kasir, minimnya kesalahan input menu, laporan cash flow akurat, kartu member digital, serta integrasi pengiriman makanan.",
    },
    {
      q: "Data apa saja yang perlu disiapkan untuk mendaftar?",
      a: (
        <ul style={{ paddingLeft: "20px", margin: 0, lineHeight: 1.8 }}>
          <li>Nama tempat usaha / outlet</li>
          <li>Alamat lengkap outlet</li>
          <li>Nama pemilik usaha (KTP)</li>
          <li>Nomor HP & email aktif pemilik</li>
          <li>Daftar menu & foto makanan/minuman</li>
        </ul>
      ),
    },
    {
      q: "Apakah bisa request demo langsung di outlet kami?",
      a: "Tentu saja! Tim Technical Consultant kami siap datang untuk melakukan presentasi dan simulasi demo sistem langsung di outlet Anda.",
    },
    {
      q: "Bagaimana mekanisme pembayaran paket langganan UR?",
      a: "Pembayaran dapat dilakukan melalui transfer bank ke rekening resmi PT. Rahmat Tuhan Lestari atau pembayaran berkala melalui sistem auto-debit.",
    },
    {
      q: "Jika saya memiliki banyak cabang, bagaimana skema biayanya?",
      a: "Setiap paket langganan berlaku untuk 1 outlet. Namun kami menyediakan paket bundling Multi-Outlet khusus dengan harga spesial untuk kepemilikan lebih dari 3 cabang.",
    },
    {
      q: "Apakah UR Partner membutuhkan perangkat hardware khusus?",
      a: "Tidak! Anda dapat menggunakan smartphone, tablet Android, iPad, ataupun laptop yang sudah Anda miliki. Kami juga mendukung berbagai printer thermal bluetooth standar di pasaran.",
    },
  ];

  const currentList = activeTab === 0 ? userFaqs : partnerFaqs;
  const filteredList = currentList.filter(
    (item) =>
      item.q.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (typeof item.a === "string" &&
        item.a.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  return (
    <div style={{ maxWidth: "100%", overflowX: "hidden", backgroundColor: "#ffffff" }}>
      <MetaTags>
        <title>Frequently Asked Questions (FAQ) | UR</title>
        <meta name="title" content="Frequently Asked Questions | UR" />
        <meta
          name="description"
          content="Pertanyaan yang sering ditanyakan seputar penggunaan aplikasi UR Self Order dan sistem kasir UR Partner."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ur-hub.com/faqs" />
      </MetaTags>

      {/* Header Banner */}
      <section
        style={{
          paddingTop: "130px",
          paddingBottom: "64px",
          backgroundColor: "#0f172a",
          color: "#ffffff",
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center" justify="space-between">
            <Grid item xs={12} md={7}>
              <div
                style={{
                  color: "#DE148C",
                  fontSize: "13px",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  marginBottom: "12px",
                }}
              >
                Pusat Informasi &amp; Bantuan
              </div>

              <Typography
                variant="h1"
                style={{
                  fontWeight: 800,
                  fontSize: "clamp(2rem, 4vw, 3.2rem)",
                  lineHeight: 1.2,
                  letterSpacing: "-0.02em",
                  marginBottom: "14px",
                }}
              >
                Pertanyaan yang Sering Diajukan
              </Typography>

              <Typography
                variant="subtitle1"
                style={{
                  color: "#94a3b8",
                  fontSize: "15px",
                  lineHeight: 1.6,
                  maxWidth: "520px",
                }}
              >
                Temukan jawaban untuk pertanyaan seputar aplikasi pemesanan UR maupun sistem kasir UR Partner.
              </Typography>
            </Grid>

            {/* Illustration */}
            <Grid item xs={12} md={5} style={{ textAlign: "center" }}>
              <img
                src="../../asset/images/Illustration/faq.png"
                alt="FAQ Illustration"
                style={{
                  maxHeight: "220px",
                  width: "auto",
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Search & Tabs Section */}
      <section style={{ padding: "32px 0", backgroundColor: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
        <Container maxWidth="md">
          {/* Tab buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "8px",
              marginBottom: "20px",
            }}
          >
            <button
              onClick={() => setActiveTab(0)}
              style={{
                padding: "8px 20px",
                borderRadius: "8px",
                border: activeTab === 0 ? "1px solid #DE148C" : "1px solid #e2e8f0",
                backgroundColor: activeTab === 0 ? "#DE148C" : "#ffffff",
                color: activeTab === 0 ? "#ffffff" : "#64748b",
                fontWeight: 600,
                fontSize: "13px",
                cursor: "pointer",
                transition: "all 0.15s ease",
              }}
            >
              FAQ Pengguna
            </button>
            <button
              onClick={() => setActiveTab(1)}
              style={{
                padding: "8px 20px",
                borderRadius: "8px",
                border: activeTab === 1 ? "1px solid #0284c7" : "1px solid #e2e8f0",
                backgroundColor: activeTab === 1 ? "#0284c7" : "#ffffff",
                color: activeTab === 1 ? "#ffffff" : "#64748b",
                fontWeight: 600,
                fontSize: "13px",
                cursor: "pointer",
                transition: "all 0.15s ease",
              }}
            >
              FAQ Merchant &amp; Partner
            </button>
          </div>

          {/* Search bar */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "10px 16px",
              borderRadius: "8px",
              backgroundColor: "#ffffff",
              border: "1px solid #e2e8f0",
            }}
          >
            <SearchIcon style={{ color: "#94a3b8", fontSize: "20px" }} />
            <input
              type="text"
              placeholder="Cari pertanyaan..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                border: "none",
                outline: "none",
                width: "100%",
                fontSize: "14px",
                color: "#0f172a",
                fontFamily: "inherit",
              }}
            />
          </div>
        </Container>
      </section>

      {/* Accordion Questions List */}
      <section style={{ padding: "48px 0 80px 0" }}>
        <Container maxWidth="md">
          {filteredList.length > 0 ? (
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              {filteredList.map((faq, idx) => (
                <Accordion
                  key={idx}
                  elevation={0}
                  style={{
                    border: "1px solid #e2e8f0",
                    borderRadius: "10px",
                    marginBottom: "6px",
                    overflow: "hidden",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon style={{ color: "#64748b" }} />}
                    style={{ padding: "14px 18px" }}
                  >
                    <Typography
                      style={{
                        fontWeight: 600,
                        fontSize: "15px",
                        color: "#0f172a",
                      }}
                    >
                      {faq.q}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails style={{ padding: "0 18px 18px 18px" }}>
                    <div style={{ color: "#475569", fontSize: "14px", lineHeight: 1.7 }}>
                      {faq.a}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}
            </div>
          ) : (
            <div style={{ textAlign: "center", padding: "60px 0", color: "#64748b" }}>
              <p>Tidak ada pertanyaan yang sesuai dengan pencarian Anda.</p>
            </div>
          )}
        </Container>
      </section>
    </div>
  );
}
